import { LOGIN, LOGOUT, REHYDRATE, CHOOSE_COMPANY, CHANGE_STATE, UPDATE_USER } from "@Actions/types";

export default function reducer(
	state = {
		isLoggedIn: false,
		userId: 0,
		name: "",
		role: null,
		menu: [],
		defaultMenu: {},
		state: "Desconectado",
		permissions: {},
		groups: [],
		token: null,
	},
	action
) {
	const { payload, type } = action;
	switch (type) {
		case LOGIN: {
			return {
				...state,
				isLoggedIn: true,
				userId: payload.data.user.id,
				name: payload.data.user.fullName,
				token: payload.data.token,
			};
		}

		case LOGOUT: {
			return {
				...state,
				isLoggedIn: false,
				userId: 0,
				name: "",
				menu: [],
				defaultMenu: {},
				state: "Desconectado",
				permissions: {},
				groups: [],
				token: null,
			};
		}

		case REHYDRATE: {
			return {
				...state,
				isLoggedIn: payload.data.user.isLoggedIn,
				userId: payload.data.user.userId,
				name: payload.data.user.name,
				role: payload.data.user.role || null,
				menu: payload.data.user.menu,
				defaultMenu: payload.data.user.defaultMenu,
				state: payload.data.user.state,
				permissions: payload.data.user.permissions,
				groups: payload.data.user.groups,
				token: payload.data.user.token,
			};
		}

		case CHOOSE_COMPANY: {
			const userPermissions = payload.data.user.permissions || {};
			return {
				...state,
				menu: payload.data.menu,
				defaultMenu: payload.data.user.defaultMenu,
				state: payload.data.user.state,
				role: payload.data.user.role,
				permissions: userPermissions,
				groups: payload.data.user.groups,
				token: payload.data.token,
			};
		}

		case CHANGE_STATE: {
			return {
				...state,
				state: payload.data,
			};
		}

		case UPDATE_USER: {
			return {
				...state,
				name: payload.data.user.fullName,
				menu: payload.data.menu,
				defaultMenu: payload.data.defaultMenu,
				permissions: { ...state.permissions, ...(payload.data.permissions || {}) },
				groups: payload.data.groups,
			};
		}

		default:
			return state;
	}
}
